import axios from '@/axios/axios.js';
import Vue from 'vue';

const util = {
  getCommunityByFullName(communityName, state) {
    let index = communityName.lastIndexOf(' ');
    let name = communityName.substring(0, index);
    let streetNumber = communityName.substring(index + 1, communityName.length);
    for (let c of state.communities) {
      if (c.address === name && c.street_number === streetNumber) {
        return c;
      }
    }
    return null;
  }
};
export default {
  state: {
    communities: [],
    activeCommunity: {},
    numOfUnreadMessages: 0,
    lastActiveCommunities: []
  },
  mutations: {
    setCommunities(state, payload) {
      state.communities = payload;
    },
    updateCommunity(state, updatedCommunity) {
      state.communities = state.communities.map(community => {
        if (community.community_id == updatedCommunity.community_id) {
          return updatedCommunity;
        }
        return community;
      });
    },
    setActiveCommunity(state, payload, showToast = false) {
      let communityId = payload;
      state.activeCommunity = state.communities.filter(
        c => c.community_id == communityId
      )[0];
      // insert in last active
      if (
        state.lastActiveCommunities.length < 5 &&
        !state.lastActiveCommunities.find(c => c.id == communityId)
      ) {
        state.lastActiveCommunities.unshift(state.activeCommunity);
      }
      if (
        state.lastActiveCommunities.length == 5 &&
        !state.lastActiveCommunities.find(c => c.id == communityId)
      ) {
        state.lastActiveCommunities.pop();
        state.lastActiveCommunities.unshift(state.activeCommunity);
      }
      const activeCommIndex = state.lastActiveCommunities.findIndex(
        c => c.id == communityId
      );
      if (state.lastActiveCommunities.length == 5 && activeCommIndex != -1) {
        state.lastActiveCommunities.splice(activeCommIndex, 1);
        state.lastActiveCommunities.unshift(state.activeCommunity);
      }
      localStorage.setItem(
        'k-last-active',
        JSON.stringify(state.lastActiveCommunities)
      );
      localStorage.setItem('k-active-c-id', payload);
    },
    setLastActiveCommunities(state, payload) {
      state.lastActiveCommunities = payload;
    },
    resetNotifications(state) {
      for (let c of state.communities) {
        c.notifications.tickets = 0;
        c.notifications.members = 0;
        c.notifications.polls = 0;
        c.notifications.unreadNotificationsCount = 0;
      }
    },
    handleNewNotification(state, payload) {
      for (let community of state.communities) {
        if (community.community_id === payload.community_id) {
          if (payload.post_type) {
            switch (payload.post_type) {
              case '1':
                //obican post
                break;
              case '2':
                //polls
                community.notifications.polls++;
                break;
              case '3':
                //event
                break;
              case '4':
                //message
                break;
            }
          } else if (payload.ticket_id) {
            community.notifications.tickets++;
          } else if (payload.body.startsWith('Zahtev za pridru')) {
            community.notifications.members++;
          }
        }
      }
    },
    handleUpdateUnreadMessagesNumber(state, totalNumOfUnreadMessages) {
      if (state.numOfUnreadMessages != totalNumOfUnreadMessages) {
        state.numOfUnreadMessages = totalNumOfUnreadMessages;
      }
    },
    handleUpdateNotifications(state, notifications) {
      for (let c of state.communities) {
        c.notifications.tickets = 0;
        c.notifications.members = 0;
        c.notifications.polls = 0;
        c.notifications.unreadNotificationsCount = 0;
      }

      for (let n of notifications) {
        if (n.is_read === '0') {
          for (let c of state.communities) {
            if (c.community_id === n.community_id) {
              c.notifications.unreadNotificationsCount++;
              switch (n.type) {
                case '10':
                  //member notification
                  c.notifications.members++;
                  break;
                case '5':
                  //ticket
                  c.notifications.tickets++;
                  break;
                case '2':
                  //polls
                  c.notifications.polls++;
                  break;
              }
            }
          }
        }
      }
    },
    lowerUnreadMessages(state, numberOfRead) {
      state.numOfUnreadMessages -= numberOfRead;
    }
  },
  actions: {
    updateNotifications(context) {
      axios
        .get('notifications/?offset=0&isManager=1&count=100')
        .then(({ data }) => {
          context.commit('handleUpdateNotifications', data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    async updateNumberOfUnreadNotifications(context) {
      let totalNumOfUnreadMessages = 0;
      let numOfUnreadMessages = 0;
      try {
        const res = await axios.post(
          '/post/get-direct-messages-inbox-manager',
          {
            num_of_posts: 50,
            timestamp: ''
          }
        );
        if (res.data.inbox_list.length > 0) {
          for (const inboxMessage of res.data.inbox_list) {
            numOfUnreadMessages += parseInt(
              inboxMessage.unread_message_counter
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
      totalNumOfUnreadMessages += numOfUnreadMessages;
      context.commit(
        'handleUpdateUnreadMessagesNumber',
        totalNumOfUnreadMessages
      );
    }
  },
  getters: {
    getCommunities(state) {
      return state.communities;
    },
    getCommunitiesImploded(state) {
      if (state.communities) {
        return state.communities.map(el => {
          return {
            id: el.id,
            name: `${el.address} ${el.street_number}, ${el.municipality_name}`,
            community_type: el.community_type,
            notifications: el.notifications.unreadNotificationsCount,
            lat: Number(el.latitude),
            lng: Number(el.longitude),
            img: el.media.link,
            imgThumb: el.media.link_to_thumb,
            mediaId: el.media.id
          };
        });
      }
      return [];
    },
    getLastActiveCommunitiesImploded(state) {
      if (state.communities) {
        return state.lastActiveCommunities.map(el => {
          return {
            id: el.id,
            name: `${el.address} ${el.street_number}, ${el.municipality_name}`,
            community_type: el.community_type,
            notifications: el.notifications.unreadNotificationsCount,
            lat: Number(el.latitude),
            lng: Number(el.longitude)
            // el.notifications.tickets +
            // el.notifications.members +
            // el.notifications.polls
          };
        });
      }
      return [];
    },
    getActiveCommunity(state) {
      return state.activeCommunity;
    },
    getLastActiveCommunities(state) {
      if (!state.lastActiveCommunities) {
        return [];
      }
      if (!state.lastActiveCommunities[0]) {
        return [];
      }
      if (state.lastActiveCommunities.length < 5) {
        if (state.lastActiveCommunities.length == 0) {
          if (state.communities.length >= 5) {
            return state.communities.slice(0, 5);
          } else {
            return state.communities;
          }
        } else {
          // find those who arent in the array
          for (const comm of state.communities) {
            if (!state.lastActiveCommunities.find(c => c.id == comm.id)) {
              state.lastActiveCommunities.push(comm);
              if (state.lastActiveCommunities.length == 5) {
                return state.lastActiveCommunities;
              }
            }
          }
        }
      }
      return state.lastActiveCommunities;
    },
    getCommunityName(state) {
      return `${state.activeCommunity.address} ${
        state.activeCommunity.street_number
      }, ${state.activeCommunity.municipality_name}`;
    },
    getCommunityType(state) {
      return state.activeCommunity.community_type;
    },
    getNumOfNotifications(state) {
      return communityId => {
        for (let c of state.communities) {
          if (c.community_id === communityId) {
            return c.notifications.unreadNotificationsCount;
            // return (
            //   c.notifications.tickets +
            //   c.notifications.polls +
            //   c.notifications.members
            // );
          }
        }
      };
    },
    isManager(state) {
      return memberId => {
        for (let c of state.communities) {
          if (c.member_id === memberId) {
            return true;
          }
        }
        return false;
      };
    },
    getCommunityIdByName(state) {
      return communityName => {
        let community = util.getCommunityByFullName(communityName, state);
        if (community) {
          return community.community_id;
        }
        return null;
      };
    },
    getManagerIdByCommunityName(state) {
      return communityName => {
        let community = util.getCommunityByFullName(communityName, state);
        if (community) {
          return community.member_id;
        }
        return null;
      };
    },
    getCommunityById(state) {
      return communityId => {
        for (let community of state.communities) {
          if (community.id == communityId) {
            return community;
          }
        }
        return null;
      };
    },
    getTotalNumberOfNotifications(state) {
      let sum = 0;
      for (let c of state.communities) {
        sum += c.notifications.unreadNotificationsCount || 0;
        // sum +=
        //   c.notifications.polls +
        //   c.notifications.members +
        //   c.notifications.tickets;
      }
      return sum === 100 ? '100+' : sum;
    },
    getNumberOfUnreadMessages(state) {
      return state.numOfUnreadMessages;
    },
    getNumOfPollsNotificationsByCommunity(state) {
      return id => {
        for (let c of state.communities) {
          if (c.community_id === id) {
            return c.notifications.polls;
          }
        }
      };
    },
    getNumOfTicketNotificationsByCommunity(state) {
      return id => {
        for (let c of state.communities) {
          if (c.community_id === id) {
            return c.notifications.tickets;
          }
        }
      };
    },
    getNumOfMemberNotificationsByCommunity(state) {
      return id => {
        for (let c of state.communities) {
          if (c.community_id === id) {
            return c.notifications.members;
          }
        }
      };
    }
  }
};
